require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./programs-strong-body-after-pain.json") })
        }
      }, "path---programs-strong-body-after-pain");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---programs-strong-body-after-pain!./.cache/json/programs-strong-body-after-pain.json
// module id = 322
// module chunks = 231608221292675